import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { ProjectGridField } from '@/types/fields'

type HoveredTableFieldContextValue = [
  ProjectGridField | null,
  Dispatch<SetStateAction<ProjectGridField | null>>,
]

const HoveredTableFieldContext = createContext<HoveredTableFieldContextValue>([
  null,
  () => {},
])

export const useHoveredTableFieldContext = () =>
  useContext(HoveredTableFieldContext)

type HoveredTableFieldProviderProps = {
  children: ReactNode
}

export default function HoveredTableFieldProvider({
  children,
}: HoveredTableFieldProviderProps) {
  const hoveredTableFieldState = useState<ProjectGridField | null>(null)

  return (
    <HoveredTableFieldContext.Provider value={hoveredTableFieldState}>
      {children}
    </HoveredTableFieldContext.Provider>
  )
}
